import { all } from 'redux-saga/effects';
import addressSaga from './address';
import childrenSaga from './children';

export const parentSaga = function* root() {
  yield all([childrenSaga(), addressSaga()]);
};
